var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurchaseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70.668,
    height: 72.969,
    viewBox: "0 0 70.668 72.969",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_10969",
    x: 0,
    y: 0,
    width: 54.217,
    height: 72.969,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cost",
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9346",
    "data-name": "Group 9346",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Path_10969)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10969-2",
    "data-name": "Path 10969",
    d: "M36.626,16H65.637a.853.853,0,0,1,.669.325l5.313,6.222a1.17,1.17,0,0,1,.277.784V69.862a1.039,1.039,0,0,1-.946,1.108H36.626a1.039,1.039,0,0,1-.946-1.108V17.109A1.039,1.039,0,0,1,36.626,16Z",
    transform: "translate(-26.68 -10)",
    fill: "#eceff1",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10970",
    "data-name": "Path 10970",
    d: "M36.626,16h1.731V70.969H36.626a1.039,1.039,0,0,1-.946-1.108V17.108A1.039,1.039,0,0,1,36.626,16Z",
    transform: "translate(-35.68 -16)",
    fill: "#d1d1d6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9345",
    "data-name": "Group 9345",
    transform: "translate(13.038 0.082)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10971",
    "data-name": "Path 10971",
    d: "M327.975,16.791a.948.948,0,0,1,.277.2l5.313,5.313a.951.951,0,0,1,.2.277h-5.313a.474.474,0,0,1-.473-.473V16.791Z",
    transform: "translate(-310.664 -16.791)",
    fill: "#a79ba7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10972",
    "data-name": "Path 10972",
    d: "M162.083,242.459a.831.831,0,1,1,0-1.661H173.61a.831.831,0,1,1,0,1.661Zm0-16.712a.831.831,0,1,1,0-1.661H173.61a.831.831,0,1,1,0,1.661Zm0-3.387a.831.831,0,1,1,0-1.661h16.541a.831.831,0,1,1,0,1.661Zm0,11.743a.831.831,0,0,1,0-1.661H173.61a.831.831,0,1,1,0,1.661Zm0-3.387a.831.831,0,0,1,0-1.661h16.541a.831.831,0,1,1,0,1.661Zm0,8.356a.831.831,0,1,1,0-1.661h16.541a.831.831,0,1,1,0,1.661Z",
    transform: "translate(-161.252 -191.497)",
    fill: "#a79ba7",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9347",
    "data-name": "Group 9347",
    transform: "translate(6.346 2.61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10973",
    "data-name": "Path 10973",
    d: "M104.295,41.227l6.554,3.784a.613.613,0,0,1,.314.543v7.568a.613.613,0,0,1-.314.544l-6.554,3.784a.613.613,0,0,1-.628,0l-6.554-3.784a.613.613,0,0,1-.314-.544V45.555a.613.613,0,0,1,.314-.543l6.554-3.784A.612.612,0,0,1,104.295,41.227Z",
    transform: "translate(-96.799 -41.141)",
    fill: "#f2d1a5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10974",
    "data-name": "Path 10974",
    d: "M173.07,80.62a.625.625,0,0,1,.082.315V88.5a.613.613,0,0,1-.314.543l-6.554,3.784a.625.625,0,0,1-.314.086v-8.2Z",
    transform: "translate(-158.788 -76.521)",
    fill: "#ecba78",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10975",
    "data-name": "Path 10975",
    d: "M105,41.227l6.554,3.784a.625.625,0,0,1,.232.229l-7.1,4.1-7.1-4.1a.625.625,0,0,1,.232-.229l6.554-3.784A.613.613,0,0,1,105,41.227Z",
    transform: "translate(-97.508 -41.14)",
    fill: "#e3a76f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10976",
    "data-name": "Path 10976",
    d: "M121.355,58.551l2.083,1.2,7.182-4.147-2.083-1.2Z",
    transform: "translate(-118.805 -53.028)",
    fill: "#c48958",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10977",
    "data-name": "Path 10977",
    d: "M122.967,98.536l-1.3-.75a.613.613,0,0,1-.314-.544v-2.9l2.083,1.2v2.722a.314.314,0,0,1-.471.272Z",
    transform: "translate(-118.805 -88.816)",
    fill: "#e3a76f",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9348",
    "data-name": "Group 9348",
    transform: "translate(5.328 43.851)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10978",
    "data-name": "Path 10978",
    d: "M88.071,378.227h3.256A1.077,1.077,0,0,1,92.4,379.3v3.256a1.077,1.077,0,0,1-1.074,1.074H88.071A1.077,1.077,0,0,1,87,382.557V379.3A1.077,1.077,0,0,1,88.071,378.227Z",
    transform: "translate(-86.997 -378.227)",
    fill: "#fe646f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10979",
    "data-name": "Path 10979",
    d: "M117.663,378.227h1.146a1.077,1.077,0,0,1,1.074,1.074v3.256a1.077,1.077,0,0,1-1.074,1.074h-1.146a1.077,1.077,0,0,0,1.074-1.074V379.3a1.078,1.078,0,0,0-1.074-1.074Z",
    transform: "translate(-114.479 -378.227)",
    fill: "#fd4755",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9349",
    "data-name": "Group 9349",
    transform: "translate(5.328 34.316)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10980",
    "data-name": "Path 10980",
    d: "M88.071,299.462h3.256a1.077,1.077,0,0,1,1.074,1.074v3.256a1.077,1.077,0,0,1-1.074,1.074H88.071A1.077,1.077,0,0,1,87,303.792v-3.256A1.077,1.077,0,0,1,88.071,299.462Z",
    transform: "translate(-86.997 -299.462)",
    fill: "#ffe177",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10981",
    "data-name": "Path 10981",
    d: "M117.663,299.463h1.146a1.077,1.077,0,0,1,1.074,1.074v3.256a1.078,1.078,0,0,1-1.074,1.074h-1.146a1.078,1.078,0,0,0,1.074-1.074v-3.256a1.077,1.077,0,0,0-1.074-1.074Z",
    transform: "translate(-114.479 -299.463)",
    fill: "#ffd064",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9350",
    "data-name": "Group 9350",
    transform: "translate(5.328 24.781)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10982",
    "data-name": "Path 10982",
    d: "M88.071,220.7h3.256a1.077,1.077,0,0,1,1.074,1.074v3.256a1.077,1.077,0,0,1-1.074,1.074H88.071A1.077,1.077,0,0,1,87,225.028v-3.256A1.077,1.077,0,0,1,88.071,220.7Z",
    transform: "translate(-86.997 -220.698)",
    fill: "#6cf5c2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10983",
    "data-name": "Path 10983",
    d: "M117.663,220.7h1.146a1.077,1.077,0,0,1,1.074,1.074v3.256a1.077,1.077,0,0,1-1.074,1.074h-1.146a1.077,1.077,0,0,0,1.074-1.074v-3.256a1.077,1.077,0,0,0-1.074-1.074Z",
    transform: "translate(-114.479 -220.698)",
    fill: "#00e499",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9351",
    "data-name": "Group 9351",
    transform: "translate(34.704 34.85)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_131",
    "data-name": "Ellipse 131",
    cx: 9.535,
    cy: 9.535,
    r: 9.535,
    transform: "translate(0 13.482) rotate(-45)",
    fill: "#ffd064"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10984",
    "data-name": "Path 10984",
    d: "M380.618,312.348a9.535,9.535,0,0,1,0,19.053q.2.008.4.008a9.535,9.535,0,0,0,0-19.069Q380.818,312.34,380.618,312.348Z",
    transform: "translate(-367.529 -308.392)",
    fill: "#f5b829",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_132",
    "data-name": "Ellipse 132",
    cx: 6.89,
    cy: 6.89,
    rx: 6.89,
    ry: 6.89,
    transform: "translate(4.028 15.719) rotate(-58.28)",
    fill: "#ffc338"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10985",
    "data-name": "Path 10985",
    d: "M318.95,344.7a6.891,6.891,0,0,1,6.479-6.878q-.2-.012-.411-.012a6.89,6.89,0,1,0,0,13.781q.207,0,.411-.012A6.891,6.891,0,0,1,318.95,344.7Z",
    transform: "translate(-311.528 -331.217)",
    fill: "#f5b829",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10986",
    "data-name": "Path 10986",
    d: "M361.052,356.955a.83.83,0,0,1-1.532.643,1.238,1.238,0,0,0-.857-.737,1.61,1.61,0,0,0-.709-.018,1.32,1.32,0,0,0-.571.257.723.723,0,0,0-.279.61.6.6,0,0,0,.3.489,2.686,2.686,0,0,0,.995.328,4.8,4.8,0,0,1,1.7.561,2.342,2.342,0,0,1,1.187,1.8c.008.064.013.143.015.236a2.12,2.12,0,0,1-.888,1.8,3.324,3.324,0,0,1-1.318.576v.228a.831.831,0,0,1-1.661,0v-.245a3.216,3.216,0,0,1-1.037-.444,2.7,2.7,0,0,1-1.147-1.619.829.829,0,0,1,1.609-.4,1.058,1.058,0,0,0,.453.633,1.782,1.782,0,0,0,1.023.27c.059,0,.137-.008.231-.019a1.8,1.8,0,0,0,.848-.3.535.535,0,0,0,.233-.448c0-.009,0-.036-.008-.08a.759.759,0,0,0-.395-.571,3.227,3.227,0,0,0-1.106-.347,4.267,4.267,0,0,1-1.631-.575,2.179,2.179,0,0,1-1.051-1.8,2.329,2.329,0,0,1,.889-1.973,2.941,2.941,0,0,1,1.088-.547v-.259a.831.831,0,0,1,1.661,0v.248A2.864,2.864,0,0,1,361.052,356.955Z",
    transform: "translate(-344.767 -345.887)",
    fill: "#ffe177",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseIcon);
export default __webpack_public_path__ + "static/media/purchase-icon.20960883ba5a7e1efd6cf9a7b7a7c464.svg";
export { ForwardRef as ReactComponent };